import { render, staticRenderFns } from "./NewSettings.vue?vue&type=template&id=d4f5d662&scoped=true"
import script from "./NewSettings.vue?vue&type=script&lang=js"
export * from "./NewSettings.vue?vue&type=script&lang=js"
import style0 from "./NewSettings.vue?vue&type=style&index=0&id=d4f5d662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f5d662",
  null
  
)

export default component.exports